import * as React from 'react';
import { SVGProps } from 'react';
const DisabledCheckbox = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 20 20' fill='none'>
    <path d='M4.25 17.5C3.764 17.5 3.35067 17.33 3.01 16.99C2.67 16.6493 2.5 16.236 2.5 15.75V4.25C2.5 3.764 2.67 3.35067 3.01 3.01C3.35067 2.67 3.764 2.5 4.25 2.5H15.75C16.236 2.5 16.6493 2.67 16.99 3.01C17.33 3.35067 17.5 3.764 17.5 4.25V15.75C17.5 16.236 17.33 16.6493 16.99 16.99C16.6493 17.33 16.236 17.5 15.75 17.5H4.25Z' />
  </svg>
);
export default DisabledCheckbox;
